import {Input} from 'antd'

import {
  Button,
  Text,
  Form,
  FormItem,
  useForm,
  useWatch,
} from 'common/components'
import {useDeleteAccount} from '..'

export default function AccountDeleteForm() {
  const {mutate: deleteAccount, isMutating} = useDeleteAccount()
  const [form] = useForm()
  const confirmValue = useWatch('confirm', form)

  const handleFinish = () => deleteAccount()

  return (
    <>
      <Text maxInterval mb={12}>
        Are you sure you want to delete your account?
      </Text>
      <Form form={form} onFinish={handleFinish}>
        <FormItem name="confirm" label={`Please type "${keyWord}" to confirm`}>
          <Input autoFocus size="large" />
        </FormItem>
        <Button
          block
          disabled={confirmValue !== keyWord}
          htmlType="submit"
          loading={isMutating}
        >
          Yes, delete account
        </Button>
      </Form>
    </>
  )
}

const keyWord = 'DELETE'
